(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["menmuse-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('mm-welcome');
  if (!dialog || dialog.dataset.initialized || /\/(?:cart|checkouts?)(?:\/|$)/.test(location.pathname)) return;
  dialog.dataset.initialized = 'true';
  const prefix = 'mm-welcome10-';
  const read = (store, key) => { try { return window[store].getItem(prefix + key); } catch { return null; } };
  const save = (store, key, value) => { try { window[store].setItem(prefix + key, value); } catch {} };
  const remove = (store, key) => { try { window[store].removeItem(prefix + key); } catch {} };
  const result = dialog.querySelector('[data-welcome-result]').dataset.welcomeResult;
  const pending = Number(read('sessionStorage', 'pending'));
  const ownResult = pending > Date.now() - 1800000 && pending <= Date.now() && Boolean(result);
  let shown = false;
  let timer;
  const eligible = () => dialog.dataset.subscribed !== 'true' && read('localStorage', 'subscribed') !== 'true' && Number(read('localStorage', 'closed-until') || 0) <= Date.now();
  const open = (force = false) => {
    if (shown || (!force && !eligible())) return;
    if (document.querySelector('dialog[open]') || document.visibilityState === 'hidden') { if (!force) timer = setTimeout(() => open(), 1000); return; }
    shown = true;
    clearTimeout(timer);
    dialog.showModal();
  };
  const close = () => {
    save('localStorage', 'closed-until', String(Date.now() + 7 * 86400000));
    clearTimeout(timer);
    dialog.close();
  };
  dialog.querySelector('.mm-welcome-close').addEventListener('click', close);
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
  });
  dialog.querySelector('form').addEventListener('submit', () => save('sessionStorage', 'pending', String(Date.now())));
  dialog.querySelector('[data-welcome-copy]').addEventListener('click', async () => {
    const status = dialog.querySelector('[data-copy-status]');
    try {
      await navigator.clipboard.writeText('WELCOME10');
      status.textContent = dialog.querySelector('[data-copy-ok]').textContent;
    } catch {
      const range = document.createRange();
      range.selectNodeContents(dialog.querySelector('code'));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      status.textContent = dialog.querySelector('[data-copy-failed]').textContent;
    }
  });
  if (ownResult) {
    remove('sessionStorage', 'pending');
    if (result === 'success') {
      save('localStorage', 'subscribed', 'true');
      dialog.querySelector('[data-welcome-entry]').hidden = true;
      dialog.querySelector('[data-welcome-success]').hidden = false;
    }
    open(true);
  } else if (eligible()) {
    timer = setTimeout(() => open(), 10000);
    document.addEventListener('mouseout', event => {
      if (!event.relatedTarget && event.clientY <= 0 && matchMedia('(hover: hover) and (pointer: fine)').matches) open();
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
